<app-cov-header
  [certificateNumber]="body.certificateNumber"
  [verificationNumber]="body.verificationNumber"
  [captchaInput]="body.captchaInput"
>
</app-cov-header>

<div id="check-certificate">
  <div class="mt-3 pt-2 mb-4">
    <p *ngIf="!isResultatenOphalenBezig">
      {{ "COV_CERTIFICAAT.TEKST1" | promptvalue | async }}
    </p>
    <p *ngIf="!isResultatenOpgehaald() && !isResultatenOphalenBezig">
      {{ "COV_CERTIFICAAT.TEKST2" | promptvalue | async }}
    </p>

    <div *ngIf="isResultatenOphalenBezig">
      <img
        id="waiting_spinner_results"
        class="waiting-spinner w-50"
        [class.hidden]="isResultatenOpgehaald()"
        src="assets/icons/loading-spinner.svg"
        alt="spinner"
      />
    </div>

    <div *ngIf="isResultatenOpgehaald() && !isResultatenOphalenBezig">
      <!-- Download button -->
      <div id="show-download-wrapper" class="mt-4 mb-5">
        <h5>{{ "COV_CERTIFICAAT.DOWNLOAD_TEKST" | promptvalue | async }}</h5>

        <div id="download-button" class="input-row mt-3">
          <div class="label"></div>
          <button
            id="download_button"
            (click)="download()"
            class="input button"
            type="button"
          >
            {{ "COV_CERTIFICAAT.DOWNLOAD_BUTTON" | promptvalue | async }}
          </button>
        </div>
      </div>

      <h5>{{ "COV_CERTIFICAAT.TEKST2" | promptvalue | async }}</h5>
    </div>
  </div>

  <div
    *ngIf="getResultaatError() != null && !isResultatenOphalenBezig"
    class="cov-error-wrapper"
  >
    <div class="danger cov-error">
      <div class="float-left">
        <h5 class="cov-error-header">{{ getResultaatError().header }}</h5>
        <h5 class="cov-error-tekst">{{ getResultaatError().tekst }}</h5>
      </div>
      <img
        src="assets/icons/ui-close-edit-box-red.svg"
        (click)="setResultaatError(null)"
        alt="close"
        class="float-right cov-error-close"
      />
    </div>
  </div>

  <div id="zoek-input-wrapper" [hidden]="isResultatenOphalenBezig">
    <div class="row">
      <label
        for="certificaat_nummer"
        class="col-label mt-1"
        style="position: static; top: 3px"
        >{{ "COV_CERTIFICAAT.CERTIFICAAT_NUMMER" | promptvalue | async }}</label
      >
      <ecert-textinput
        [clear_button]="false"
        [error]="certificaatError"
        [id]="'certificaat_nummer'"
        [maxlength]="14"
        [ref_object]="body"
        [tooltip]="
          language === 'ES' ? 'Número del certificado' : 'Certificate number'
        "
        class="input col-input"
        foutmelding="COV_CERTIFICAAT.CERTIFICAAT_FOUTMELDING"
        property="certificateNumber"
      >
      </ecert-textinput>
    </div>

    <div class="row mt-4">
      <label for="verificatie_nummer" class="label col-label mt-1">
        {{ "COV_CERTIFICAAT.VERIFICATIE_NUMMER" | promptvalue | async }}</label
      >
      <ecert-textinput
        [id]="'verificatie_nummer'"
        [ref_object]="body"
        property="verificationNumber"
        class="input col-input"
        [maxlength]="19"
        [pattern]="verificatiePattern"
        [tooltip]="
          language === 'ES' ? 'Número del verificación ' : 'Verification number'
        "
        placeholder="____-____-____-____"
        [error]="verificatieError"
        foutmelding="COV_CERTIFICAAT.VERIFICATIE_FOUTMELDING"
        [clear_button]="false"
      >
      </ecert-textinput>
    </div>

    <div class="row mt-3">
      <label class="label col-label mt-1"></label>
      <canvas id="canvas" width="260" height="50"> </canvas>

      <button
        id="reload-button"
        (click)="reloadCaptchaText(false)"
        class="input button ml-auto mt-2 mr-3"
      >
        {{ "COV_CERTIFICAAT.RELOAD_BUTTON" | promptvalue | async }}
      </button>
    </div>

    <div class="row mb-3">
      <label class="label col-label mt-1" for="captcha_input">{{
        "COV_CERTIFICAAT.CAPTCHA_LABEL" | promptvalue | async
      }}</label>
      <ecert-textinput
        [id]="'captcha_input'"
        [ref_object]="body"
        property="captchaInput"
        class="input col-input"
        [maxlength]="9"
        [error]="captchaError"
        [tooltip]="
          language === 'ES'
            ? 'Escriba el texto anterior'
            : 'Type the above text'
        "
        foutmelding="COV_CERTIFICAAT.CAPTCHA_FOUTMELDING"
        [clear_button]="false"
      >
      </ecert-textinput>
    </div>

    <div class="row mt-4 pt-2">
      <div class="label col-label"></div>
      <button
        id="verifieer_button"
        (click)="verifyInputValues('N')"
        class="input button ml-3"
        style="width: 100px"
        [disabled]="isDisabled()"
      >
        {{ "COV_CERTIFICAAT.VERIFIEER_BUTTON" | promptvalue | async }}
      </button>
    </div>
  </div>
</div>

<div class="wrapper">
  <div class="footer-container">
    <div class="footer-section">
      <h1>{{ getPrompt("COV_CERTIFICAAT.SERVICE") | promptvalue | async }}</h1>
      <p>
        <a
          target="_blank"
          rel="noopener"
          style="color: white"
          href="{{
            getPrompt('COV_CERTIFICAAT.URL_CONTACT') | promptvalue | async
          }}"
        >
          {{ getPrompt("COV_CERTIFICAAT.CONTACT") | promptvalue | async }}
        </a>
      </p>
    </div>

    <div class="footer-section">
      <h1>{{ getPrompt("COV_CERTIFICAAT.TALEN") | promptvalue | async }}</h1>
      <p>
        <a
          style="color: white"
          [routerLink]="['/en']"
          (click)="changeLanguage('EN')"
          >{{ getPrompt("COV_CERTIFICAAT.ENGELS") | promptvalue | async }}
        </a>
        <a
          style="color: white"
          [routerLink]="['/es']"
          (click)="changeLanguage('ES')"
          >{{ getPrompt("COV_CERTIFICAAT.SPAANS") | promptvalue | async }}
        </a>
      </p>
    </div>
  </div>
</div>
